import { v4 as uuid } from 'uuid';

/**
 * @typedef {Object} cell
 * @property {Array} _coordinates [rowIndex, columnIndex] _coordinates for current
 *                                or (target if merged) cell.
 * @property {string} _id UU_id for cell.
 */

class Cell {
  // #coordinates
  // #id

  get row() {
    return this._coordinates[0];
  }
  get column() {
    return this._coordinates[1];
  }
  get id(){
    return this._id;
  }
  get coordinates(){
    return this._coordinates;
  }

  /**
   * Create new Cell instance.
   * 
   * @param {object} config cell configuration object.
   */
  constructor(config){
    // val_idate.constructor();
    this._coordinates = config.coordinates;
    this._id = (config.id) ? config.id : uuid();
    return this;
  }

  /**
   * Update cell _coordinates
   * 
   * @returns {cell} Cell instance.
   */
  update(coordinates) {
    this._coordinates = coordinates;
    return this;
  }

  /**
   * Get cell data.
   * 
   * @returns {cell}
   */
  get() {
    return {
      coordinates: this._coordinates,
      id: this._id,
    };
  }

  /**
   * Compare the _coordinates for 2 different cell instances.
   * 
   * @param {cell} otherCell 
   * @returns {boolean}
   */
  isSame(otherCell) {
    return (`${this._coordinates}` === `${otherCell._coordinates}`);
  }

  /**
   * Remove any reference cells leaving only target cells.
   * NOTE: A reference cell is a cell that has been merged and
   * references the "target" cell. This will return 1 cell for
   * each merged cell.
   * 
   * @param {Array} cells List of cell instances.
   * @returns {Array} List of target cell instances.
   */
  static getUnique(cells) {
    const uniqueCells = [];
    cells.forEach((cell) => {
      if (uniqueCells.filter(uniqueCell => cell.isSame(uniqueCell)).length === 0) {
        uniqueCells.push(cell);
      }
    });
    return uniqueCells;
  }
}

export default Cell;